import { createSlice } from '@reduxjs/toolkit'

export const feedbackSlice = createSlice({
  name: 'feedback',
  initialState: {
    title: 'Qroq Feedback',
    fontFamily: 'Arial, sans-serif',
    cardColor: '#ffffff',
    titleColor: '#000000',
    reviewTextColor: '#000000',
    labelColor: '#000000',
    sendButtonBackgroundColor: '#1e2746',
    sendButtonTextColor: '#ffffff'
  },
  reducers: {
    setFeedbackField(state, action) {
      state[action.payload.key] = action.payload.val
    },
    initializeFeedback(state, action) {
      state.title = 'Qroq Feedback'
      state.fontFamily = 'Arial, sans-serif'
      state.cardColor = '#ffffff'
      state.titleColor = '#000000'
      state.reviewTextColor = '#000000'
      state.labelColor = '#000000'
      state.sendButtonBackgroundColor = '#1e2746'
      state.sendButtonTextColor = '#ffffff'
    }
  }
})

export const {
  setFeedbackField,
  initializeFeedback
} = feedbackSlice.actions
export default feedbackSlice.reducer